module.exports = __webpack_public_path__ + "img/Afghanistan.e1ccec59.svg";